var MDB = window.MDB || {};

(function ($) {
    /*
    if (!$.fn.datepicker.dates) $.fn.datepicker.dates = {};
    $.fn.datepicker.dates.nl = {
        en: {
            days: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"],
            daysShort: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"],
            daysMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"],
            months: ["Januari", "Februari", "Maart", "April", "Mei", "Junie", "Julie", "Augustus", "September", "Oktober", "November", "December"],
            monthsShort: ["Jan", "Feb", "Maa", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            today: "Today",
            clear: "Clear"
        }
    };*/

    var EventManagerFieldTypes = {
        Integer: 0,
        DateTime: 1,
        String: 2,
        Guid: 3
    };

    $.extend(MDB,
        {
            eventManagerBootEdit: function (e) {
                MDB.eventManagerWireButtons();
                MDB.eventManagerWireCategories();
            },

            eventManagerWireButtons: function () {
                $('.conditions-form').on('click', '.btn-add', MDB.eventManagerAddConditionButtonClicked);
                $('.conditions-form').on('click', '.btn-remove', MDB.eventManagerRemoveConditionButtonClicked);
                $('.btn-save').bind('click', MDB.eventManagerSaveButtonClicked);

                $('#btn-calculate-selected-records').bind('click', MDB.eventManagerCalculateSelectedRecordsButtonClicked);
                $('#delete-link').bind('click', MDB.eventManagerDeleteButtonClicked);
            },

            eventManagerWireCategories: function () {
                var root = $('body').data('siteroot');
                var api = root + 'api/EventManager/';
                var me = this;
                var form = $('.conditions-form');
                form.on('change', '.property-category', function (e) {
                    //cat changed, 
                    var category = $(this);
                    var val = category.val();

                    if (val) {
                        $.ajax({
                            url: api + val
                        }).done(function (data) {
                            // property
                            // $('select.property').data('datatype')
                            var prop = category.parents('div.sub-condition').find('select.property');
                            prop.find('option').remove();
                            $('<option />').attr('value', '').text(MDB.loadResourceString('AbstractTag_Edit_Condition_Property_DefaultOption')).appendTo(prop);
                            for (var i = 0; i < data.length; i++) {
                                $('<option />')
                                    .attr('data-datatype', data[i].DataFieldType)
                                    .data('datatype', data[i].DataFieldType)
                                    .attr('value', data[i].DataFieldName)
                                    .text(data[i].DataFieldName)
                                    .appendTo(prop);
                            }
                        });
                    }
                });
                form.on('change', '.property', function (e) {
                    var property = $(this);
                    var val = property.val();
                    var dataType = property.find('option[value="' + val + '"]').data('datatype');
                    var valueField = property.parents('div.sub-condition').find('input.operator-value');

                    if (valueField.data('datatype') != dataType) {
                        valueField.data('lastvalue', '');
                    }

                    valueField.data('datatype', dataType);
                    switch (dataType) {
                    case EventManagerFieldTypes.Integer:
                        valueField.prop('placeholder', MDB.loadResourceString('AbstractTag_Edit_Condition_OperatorValue_Placeholder_Integer'));
                        break;
                    case EventManagerFieldTypes.DateTime:
                        valueField.prop('placeholder', MDB.loadResourceString('AbstractTag_Edit_Condition_OperatorValue_Placeholder_DateTime'));
                        /*valueField.datepicker({
                                format: 'dd-mm-yyyy', language: 'nl'
                            });*/
                        break;
                    case EventManagerFieldTypes.Guid:
                        valueField.prop('placeholder', MDB.loadResourceString('AbstractTag_Edit_Condition_OperatorValue_Placeholder_Guid'));
                        break;
                    case EventManagerFieldTypes.String:
                        valueField.prop('placeholder', '');
                        break;
                    default:
                        valueField.prop('placeholder', '');
                        break;
                    }
                    valueField.trigger('validate');
                    // eventManagerValidateDatatypes
                    // self.parents('.sub-condition');
                });
                form.on('change validate', 'select.operator-type', function (e) {

                });
                form.on('change validate', 'input.operator-value', function (e) {
                    if (form.find('.condition-type').val() == 4) {
                        /* method */return; 
                    }
                    var me = $(this);
                    var dt = me.data('datatype');
                    var re = /.*/;
                    switch (dt) {
                    case EventManagerFieldTypes.Integer:
                        re = /^\d*$/;
                        break;
                    case EventManagerFieldTypes.DateTime:
                        re = /^(\d{1,2}-\d{1,2}-\d{4})?$/;
                        break;
                    case EventManagerFieldTypes.Guid:
                        re = /^\{?[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\}?$/i;
                        this.value = this.value.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
                        break;
                    case EventManagerFieldTypes.String:
                        break;
                    default:
                        break;
                    }
                    if (this.value && !re.test(this.value)) {
                        if (!me.hasClass('error')) {
                            me.addClass('error');
                        }
                        this.value = me.data('lastvalue') || '';
                    } else {
                        me.data('lastvalue', this.value);
                        if (me.hasClass('error')) {
                            me.removeClass('error');
                        }
                    }
                });
                form.on('keydown', 'input.operator-value', function (e) {
                    if (!this.value) {
                        return;
                    }
                    if (form.find('.condition-type').val() == 4) {
                        /* method */return; 
                    }

                    var me = $(this);
                    var dt = me.data('datatype');
                    var re = /.*/;

                    switch (dt) {
                    case EventManagerFieldTypes.Integer:
                        re = /^\d*/;
                        break;
                    case EventManagerFieldTypes.DateTime:
                        re = /^\d{0,2}(-(\d{1,2}(-(\d{1,4})?)?)?)?$/;
                        break;
                    case EventManagerFieldTypes.Guid:
                        re = /^\{?[a-f0-9-]{0,36}\}?$/i;
                        if (re.test(this.value)) {
                            this.value = this.value.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
                        }
                        break;
                    case EventManagerFieldTypes.String:
                        break;
                    default:
                        break;
                    }
                    if (!re.test(this.value)) {
                        e.preventDefault();
                        this.value = me.data('lastvalue') || '';
                    } else {
                        me.data('lastvalue', this.value);
                    }
                });
            },

            eventManagerCalculateSelectedRecordsButtonClicked: function () {
                var target = $('#selected-records');
                target.text('');
                target.addClass('fa-spin');
                target.addClass('fa-circle-o-notch');

                // zet de voorwaarden boom in het hiddenfield
                MDB.eventManagerSaveButtonClicked();
                var requestData = $('#SerializedForm').val();

                requestData = { json: requestData };

                var eventCountUntagged = MDB.callApi({
                    cache: false,
                    method: 'POST',
                    url: 'EventManagerControler/ConditionCount',
                    data: requestData
                });

                // reset record count 
                eventCountUntagged.done(function (data) {
                    target.removeClass('fa-spin');
                    target.removeClass('fa-circle-o-notch');
                    target.text(data['records']);
                });
                eventCountUntagged.fail(function (xhr, status, serverStatus) {
                    var msg = 'Er is iets foutgegaan bij het verwerken van de opdracht';
                    try {
                        var data = xhr.responseJSON;
                        if (data.ExceptionType == 'MarketingDb.Domain.Zeiss.Services.UnsupportedSqlMethodException'
                            && data.ExceptionMessage.indexOf(':') != -1) {
                            msg = sprintf(
                                MDB.loadResourceString('AbstractTag_Edit_RecordsCounter_ErrorMessage_UnsupportedSqlMethod'),
                                data.ExceptionMessage.substr(data.ExceptionMessage.indexOf(':') + 1));
                        } else if (data.ExceptionType) {
                            msg = data.ExceptionType + ': ' + MDB.loadResourceString('AbstractTag_Edit_RecordsCounter_ErrorMessage_Generic');
                        }
                    } catch (e) {
                        // oops
                    }
                    if (msg) {
                        alert(msg);
                    }
                });
            },
            eventManagerDeleteButtonClicked: function (e) {
                e.preventDefault();
                var url = this.getAttribute("href");

                MDB.promptWithIcon(
                    MDB.loadResourceString('AbstractTag_Edit_Delete_Warning_Title'),
                    MDB.loadResourceString('AbstractTag_Edit_Delete_Warning'),
                    'fas fa-exclamation-triangle text-warning',
                    function(ok) {
                        if(ok) {
                            window.location.href=url;
                        }
                    }
                );
            },
            // event manager
            eventManagerAddConditionButtonClicked: function (e) {
                // add row
                var $this = $(this);
                var isCondition = $this.data('target') === 'condition';
                
                var rowModel = $this.closest('.duplicate-row');
                var target = isCondition ? rowModel.find('.toplevel-condition') : rowModel.closest('.duplicate-rows');
                var model = isCondition ? rowModel.find('.toplevel-condition-model > ') : rowModel;

                var prot = model.clone();
                
                if(!isCondition){
                    //Clear all sub conditions from our toplevel condition for a clean slate
                    prot.find('.toplevel-condition .sub-condition').remove();
                }
                
                prot.find('select,input').val('');
                
                target.append(prot);

            },
            eventManagerRemoveConditionButtonClicked: function (e) {
                var button = $(this);
                button.parents('.duplicate-rows').children(":first").attr('class');
                
                MDB.promptWithIcon(
                    MDB.loadResourceString('AbstractTag_Edit_Condition_Delete_Warning_Title'),
                    MDB.loadResourceString('AbstractTag_Edit_Condition_Delete_Warning'),
                    'fas fa-exclamation-triangle text-warning',
                    function(ok) {
                        if(ok) {
                            button.closest(".duplicate-row").remove();
                        }
                    }
                );
            },
            eventManagerSaveButtonClicked: function (e) {
                var errors = false;
                // serialize form ...
                var hidden = $('#SerializedForm');
                var items = [];
                var tlcs = $('.conditions-form .toplevel-condition');
                tlcs.each(function () {
                    var tlc = { type: '&', items: [] };

                    $(this).find('.sub-condition').each(function () {
                        var result = {};
                        var me = $(this);
                        var pt = 0;
                        var value = me.find('.operator-value').val();
                        if (me.hasClass('tag-condition') && value === '') {
                            return false;
                        }

                        //var pt = me.find('.property-type').val();
                        // serialize values
                        result.ConditionType = 3; // 0 = and, 3 = property
                        result.Value = value;
                        result.Property = me.find('.property').val();

                        $('select.property option').each(function () {
                            var me = $(this);
                            if (me.prop('value') == result.Property) {
                                pt = parseInt(me.data('datatype'), 10);
                                return false;
                            }
                        });
                        result.PropertyType = parseInt(pt, 10);
                        result.OperatorType = me.find('.operator').val();
                        result.ConditionType = parseInt(me.find('.condition-type').val(), 10);
                        tlc.items.push(result);
                        
                        var err = pt !== '' || result.Property || (!result.OperatorType && result.OperatorType !== 0);

                        if (err) {
                            //if (me.find('input.operator-value'))
                            me.find("select.property, select.operator").each(function () {
                                var me = $(this);
                                if (!me.hasClass('operator-value')) {
                                    if (me.val() == '') {
                                        me.addClass('error');
                                    } else {
                                        me.removeClass('error');
                                    }
                                }
                            });
                            err = me.find('input.error, select.error').length > 0;
                        } else {
                            me.find("input,select").removeClass('error');
                        }
                        errors = errors || err;
                    });

                    if (tlc.items.length !== 0) {
                        items.push(tlc);
                    }
                });

                //serialize array
                var ser = JSON.stringify(items);
                hidden.val(ser);
                if (errors) {
                    console.log("Validation errors");
                    return false;
                }
            }
        });

})(jQuery);